import { BodyMediumMidEmphasis, BodySmall } from '@/design-system';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import colors from '@/theme/colors';
import styles from './EmailNotificationsBanner.styles';
import { APP_ROUTES } from '@/config/constants';
import React from 'react';
import { AccessibleDivButton } from '@/components';

type Props = {
  isNotificationEnabled: boolean;
};

const EmailNotificationsBanner: React.FC<Props> = ({ isNotificationEnabled }) => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate(APP_ROUTES.notifications);
  };

  return (
    <AccessibleDivButton
      className={styles.container}
      onClick={onClick}
      data-testid="emailNotificationsBanner"
      role="link"
    >
      <BodyMediumMidEmphasis data-testid="cardTitle" color={colors.shadesJungle800}>
        Turn {isNotificationEnabled ? 'Off' : 'On'} Email Notifications
      </BodyMediumMidEmphasis>
      <div>
        <BodySmall data-testid="cardDescription" color={colors.charcoal}>
          Manage email notifications sent from schools.
        </BodySmall>
      </div>
      <div className={styles.arrowRightIcon}>
        <ArrowForwardIosIcon />
      </div>
    </AccessibleDivButton>
  );
};

export default EmailNotificationsBanner;
